import { useRef, useState } from "react"

export const useDelayedState = <T> (defaultValue: T | (() => T)) => {
    const [value, setValue] = useState<T>(defaultValue);
    const lastSet = useRef<Date>(new Date());

    const setter = (value: React.SetStateAction<T>, minDelay=0) => {
        const now = new Date();
        const diff = now.getTime() - lastSet.current.getTime();
        const delay = Math.max(0, minDelay - diff);
        if (delay) {
            setTimeout(() => {
                setValue(value);
                lastSet.current = new Date();
            }, delay);
        } else {
            setValue(value);
            lastSet.current = new Date();
        }
    };

    return [value, setter] as const;
}